import { MoneyFormatter } from '@sembo-private/money';
import '@vue/compiler-dom';
import { setDefaultOptions } from 'date-fns';
import { createPinia } from 'pinia';
import 'regenerator-runtime/runtime';
import { createApp } from 'vue';

import {
  i18n,
  loadLanguageAsync,
} from '@apps/main/modules/localization/localizationSetup';
import router from '@apps/main/modules/router/routerSetup';

import { getLocale } from '@libs/sembo-dates';
import { decodeHTML } from '@libs/utils';
import {
  assignExperimentValue,
  getExperiment,
  initializeStatsig,
  trackPerformance,
} from '@libs/feature-toggle';

import App from './App.vue';
import { addCustomDirectives } from './directives';
import './styles/main.scss';
import { createLogger } from './modules/plugins/logger';
import { languageLocale } from './modules/localization/localeUtils';

if (decodeHTML(location.href) !== location.href) {
  location.href = decodeHTML(location.href) ?? location.href;
}

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);

(async function (): Promise<void> {
  await MoneyFormatter.GetInstanceAsnyc();
  await initializeStatsig();

  const isHotelDetailsRoomCardsGridLayoutExperiment = getExperiment(
    'hotel_details_room_cards_grid_layout'
  ).get('hotel_details_room_cards_grid_layout', false);
  assignExperimentValue(
    'hotel_details_room_cards_grid_layout',
    isHotelDetailsRoomCardsGridLayoutExperiment
  );

  const isNewPriceCalendarOnCarTripExperiment = getExperiment(
    'new_price_calendar_on_car_trip'
  ).get('should_show_new_price_calendar_on_car_trip', false);
  assignExperimentValue(
    'new_price_calendar_on_car_trip',
    isNewPriceCalendarOnCarTripExperiment
  );

  const isPreviouslySeenHotelsInHotelList = getExperiment(
    'previously_seen_hotels_in_hotel_list'
  ).get('should_show_previously_seen_hotels_in_hotel_list', false);
  assignExperimentValue(
    'previously_seen_hotels_in_hotel_list',
    isPreviouslySeenHotelsInHotelList
  );

  const isHotelSelectionSemboBenefitsExperiment = getExperiment(
    'hotel_selection_sembo_benefits'
  ).get('should_show_hotel_selection_sembo_benefits', false);
  assignExperimentValue(
    'hotel_selection_sembo_benefits',
    isHotelSelectionSemboBenefitsExperiment
  );

  const isPriceCalendarExperiment = getExperiment('new_price_calendar').get(
    'should_show_new_price_calendar',
    false
  );
  assignExperimentValue('new_price_calendar', isPriceCalendarExperiment);

  const isHotelGuestRatingExperiment = getExperiment('hotel_guest_rating').get(
    'should_show_hotel_guest_rating',
    false
  );
  assignExperimentValue('hotel_guest_rating', isHotelGuestRatingExperiment);

  const isCalendarWithoutPricesInCarTripExperiment = getExperiment(
    'calendar_without_prices_in_car_trip'
  ).get('should_show_calendar_without_prices_in_car_trip', false);
  assignExperimentValue(
    'calendar_without_prices_in_car_trip',
    isCalendarWithoutPricesInCarTripExperiment
  );
})();

const logger = createLogger();
app.use(logger);

app.use(router);
app.use(i18n);

app.mount('#app');

addCustomDirectives(app);

setDefaultOptions({
  locale: getLocale(languageLocale),
});

loadLanguageAsync(languageLocale);

trackPerformance();
